import { render, staticRenderFns } from "./cart-large.vue?vue&type=template&id=52c70376&"
import script from "./cart-large.vue?vue&type=script&lang=js&"
export * from "./cart-large.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports